/**
 * Set a cookie that expires at the end of the current day (23:59:59).
 * @param name - Cookie name
 * @param value - Cookie value
 */
export function setCookieExpiringToday(name: string, value: string): void {
  const now = new Date();
  const expires = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59
  ).toUTCString();

  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

/**
 * Get a cookie by name.
 * @param name - Cookie name
 * @returns Cookie value or null if not found
 */
export function getCookie(name: string): string | null {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) return decodeURIComponent(value);
  }

  return null;
}

/**
 * Check if a cookie exists with a specific value.
 * @param name - Cookie name
 * @param expectedValue - Expected value
 * @returns boolean
 */
export function isCookieValue(name: string, expectedValue: string): boolean {
  return getCookie(name) === expectedValue;
}
